import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef, Component, Input, NgZone, OnInit
} from '@angular/core';

import { SondermindApplicationService } from '@sondermind/data-access/sondermind-app-service';
import { ServerResponse } from '@sondermind/utilities/models-http';

@Component({
  selector: 'error-list',
  imports: [CommonModule],
  templateUrl: './error-list.component.html'
})
export class ErrorListComponent implements OnInit {
  @Input() error_list: { [index: string]: any; } = {};
  @Input() system_errors: string[] = [];

  constructor(
    private appService: SondermindApplicationService,
    private changeRef: ChangeDetectorRef,
    private zone: NgZone
  ) {
  }

  get errorList(): string[] {
    const errors: string[] = [];
    /* eslint-disable no-restricted-syntax */
    /* eslint-disable guard-for-in */
    for (const object_name in this.error_list) {
      if ({}.hasOwnProperty.call(this.error_list, object_name)) {
        for (const field_name in this.error_list[object_name]) {
          if ({}.hasOwnProperty.call(this.error_list[object_name], field_name)) {
            for (const value in this.error_list[object_name][field_name].values) {
              if ({}.hasOwnProperty.call(this.error_list[object_name][field_name].values, value)) {
                errors.push(this.error_list[object_name][field_name].values[value]);
              }
            }
          }
        }
      }
    }
    /* eslint-enable no-restricted-syntax */
    /* eslint-enable guard-for-in */

    errors.concat(this.system_errors);
    return errors;
  }

  ngOnInit(): void {
    this.appService.errorsUpdated.subscribe((serverResponse) => this.updateErrorList(serverResponse));
  }

  setSystemErrors(serrors: string[]): void {
    this.changeRef.detectChanges();
    this.zone.run(() => {
      this.system_errors = serrors;
    });
  }

  private updateErrorList(serverResponse: ServerResponse): void {
    this.zone.run(() => {
      this.error_list = serverResponse.errors;
      this.system_errors = serverResponse.system_errors;
    });
  }
}
